import { io, Socket } from 'socket.io-client';
import { getToken } from './auth';
import { getSystemConfig } from './systemConfig';

let socket: Socket | null = null;

/**
 * Connect to Socket.io server
 */
export function connectSocket(): Socket | null {
  // Reuse the shared instance even while connecting so listeners stay on one socket.
  if (socket) {
    if (!socket.connected) {
      socket.connect();
    }
    return socket;
  }

  // Prefer explicit API host; otherwise same origin (Vite proxies /socket.io in dev,
  // which also works when opening the app via LAN IP from an iPad).
  const configuredApi = import.meta.env.VITE_API_URL;
  const apiUrl = configuredApi
    ? configuredApi.replace(/\/api\/?$/, '')
    : window.location.origin;
  const token = getToken();
  const { clientRuntime } = getSystemConfig();

  socket = io(apiUrl, {
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: clientRuntime.socketReconnectionDelayMs,
    reconnectionAttempts: clientRuntime.socketReconnectionAttempts,
  });

  socket.on('connect', () => {
    console.log('Socket connected', { socketId: socket?.id });
  });

  socket.on('disconnect', (reason) => {
    console.log('Socket disconnected', { reason });
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error', error);
  });

  return socket;
}

/**
 * Disconnect from Socket.io server
 */
export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

/**
 * Get the current socket instance
 */
export function getSocket(): Socket | null {
  return socket;
}

/**
 * Check if socket is connected
 */
export function isSocketConnected(): boolean {
  return socket?.connected || false;
}

